const editProfile = 'https://members.cj.com/member/app/profile/edit'
const manageAccounts = 'https://members.cj.com/member/app/profile/manageAccounts'

export const redirectTarget = (pathname) =>
  pathname.split('/')[1] === 'manage-accounts' ? manageAccounts : editProfile
